import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import JSONPretty from "react-json-pretty";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-json-pretty/themes/monikai.css"; // Optional: Use a theme
const JobPostingSchemaForm = () => {
  const [formData, setFormData] = useState({
    title: "",
    identifier: "",
    description: "",
    companyName: "",
    companyUrl: "",
    companyLogo: "",
    industry: "",
    employmentType: "FULL_TIME",
    workHours: "",
    datePosted: "",
    validThrough: "",
    remoteJob: false,
    country: "",
    streetAddress: "",
    city: "",
    state: "",
    postalCode: "",
    salary: "",
    maxSalary: "",
    currency: "USD",
    salaryPeriod: "Year",
    responsibilities: "",
    skills: "",
    qualifications: "",
    educationRequirements: "",
    experienceRequirements: "",
  });

  const [schema, setSchema] = useState({
    "@context": "https://schema.org",
    "@type": "JobPosting",
    title: "",
    description: "",
    hiringOrganization: {
      "@type": "Organization",
      name: "",
      sameAs: "",
      logo: "",
    },
    datePosted: "",
    validThrough: "",
    employmentType: "FULL_TIME",
    industry: "",
    workHours: "",
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        streetAddress: "",
        addressLocality: "",
        addressRegion: "",
        postalCode: "",
        addressCountry: "",
      },
    },
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "USD",
      value: {
        "@type": "QuantitativeValue",
        minValue: "",
        maxValue: "",
        unitText: "Year",
      },
    },
    responsibilities: "",
    skills: "",
    qualifications: "",
    educationRequirements: "",
    experienceRequirements: "",
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const generateSchema = () => {
    const newSchema = {
      "@context": "https://schema.org",
      "@type": "JobPosting",
      title: formData.title,
      description: formData.description,
      hiringOrganization: {
        "@type": "Organization",
        name: formData.companyName,
        sameAs: formData.companyUrl,
        logo: formData.companyLogo,
      },
      datePosted: formData.datePosted,
      validThrough: formData.validThrough,
      employmentType: formData.employmentType,
      industry: formData.industry,
      workHours: formData.workHours,
      jobLocation: formData.remoteJob
        ? { "@type": "Place", name: "Remote" }
        : {
            "@type": "Place",
            address: {
              "@type": "PostalAddress",
              streetAddress: formData.streetAddress,
              addressLocality: formData.city,
              addressRegion: formData.state,
              postalCode: formData.postalCode,
              addressCountry: formData.country,
            },
          },
      baseSalary: {
        "@type": "MonetaryAmount",
        currency: formData.currency,
        value: {
          "@type": "QuantitativeValue",
          minValue: formData.salary,
          maxValue: formData.maxSalary,
          unitText: formData.salaryPeriod,
        },
      },
      responsibilities: formData.responsibilities,
      skills: formData.skills,
      qualifications: formData.qualifications,
      educationRequirements: formData.educationRequirements,
      experienceRequirements: formData.experienceRequirements,
    };
    setSchema(newSchema);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    generateSchema();
  };

   const copyToClipboard = () => {
     navigator.clipboard.writeText(JSON.stringify(schema, null, 2)).then(() => {
       toast.info("JSON-LD copied to clipboard!");
     });
   };
const deleteSchema = () => {
    setSchema({
      "@context": "https://schema.org",
      "@type": "JobPosting",
      title: "",
      description: "",
      hiringOrganization: {
        "@type": "Organization",
        name: "",
        sameAs: "",
        logo: "",
      },
      datePosted: "",
      validThrough: "",
      employmentType: "FULL_TIME",
      industry: "",
      workHours: "",
      jobLocation: {
        "@type": "Place",
        address: {
          "@type": "PostalAddress",
          streetAddress: "",
          addressLocality: "",
          addressRegion: "",
          postalCode: "",
          addressCountry: "",
        },
      },
      baseSalary: {
        "@type": "MonetaryAmount",
        currency: "USD",
        value: {
          "@type": "QuantitativeValue",
          minValue: "",
          maxValue: "",
          unitText: "Year",
        },
      },
      responsibilities: "",
      skills: "",
      qualifications: "",
      educationRequirements: "",
      experienceRequirements: "",
    });
    toast.warning("Schema reset to dummy data!");
  };
  
  return (
    <div className="container mt-4">

      <ToastContainer/>
      <div className="row">
        <div className="col-md-6">
        <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        {/* Job Title and Identifier */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Job's Title</label>
            <input
              type="text"
              className="form-control"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="Enter job title"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Identifier</label>
            <input
              type="text"
              className="form-control"
              name="identifier"
              value={formData.identifier}
              onChange={handleInputChange}
              placeholder="Enter job identifier"
            />
          </div>
        </div>

        {/* Description */}
        <div className="mb-3">
          <label className="form-label">Job's Description (HTML)</label>
          <textarea
            className="form-control"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            placeholder="Enter job description in HTML"
            rows="4"
          ></textarea>
        </div>

        {/* Company Details */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Company Name</label>
            <input
              type="text"
              className="form-control"
              name="companyName"
              value={formData.companyName}
              onChange={handleInputChange}
              placeholder="Enter company name"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Company URL</label>
            <input
              type="text"
              className="form-control"
              name="companyUrl"
              value={formData.companyUrl}
              onChange={handleInputChange}
              placeholder="Enter company URL"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Company Logo</label>
            <input
              type="text"
              className="form-control"
              name="companyLogo"
              value={formData.companyLogo}
              onChange={handleInputChange}
              placeholder="Enter company logo URL"
            />
          </div>
        </div>

        {/* Industry and Employment Type */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Industry</label>
            <input
              type="text"
              className="form-control"
              name="industry"
              value={formData.industry}
              onChange={handleInputChange}
              placeholder="Enter industry"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Employment Type</label>
            <select
              name="employmentType"
              className="form-select"
              value={formData.employmentType}
              onChange={handleInputChange}
            >
              <option value="FULL_TIME">Full-Time</option>
              <option value="PART_TIME">Part-Time</option>
              <option value="CONTRACTOR">Contractor</option>
              <option value="TEMPORARY">Temporary</option>
              <option value="INTERN">Intern</option>
            </select>
          </div>
        </div>

        {/* Dates */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Date Posted</label>
            <input
              type="date"
              className="form-control"
              name="datePosted"
              value={formData.datePosted}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Expire Date</label>
            <input
              type="date"
              className="form-control"
              name="validThrough"
              value={formData.validThrough}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {/* Location */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">
              <input
                type="checkbox"
                name="remoteJob"
                checked={formData.remoteJob}
                onChange={handleInputChange}
              />
              &nbsp; Remote Job
            </label>
          </div>
        </div>

        {!formData.remoteJob && (
          <>
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Country</label>
                <input
                  type="text"
                  className="form-control"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  placeholder="Enter country"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">City</label>
                <input
                  type="text"
                  className="form-control"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  placeholder="Enter city"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">State/Province</label>
                <input
                  type="text"
                  className="form-control"
                  name="state"
                  value={formData.state}
                  onChange={handleInputChange}
                  placeholder="Enter state/province"
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Street Address</label>
                <input
                  type="text"
                  className="form-control"
                  name="streetAddress"
                  value={formData.streetAddress}
                  onChange={handleInputChange}
                  placeholder="Enter street address"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Postal Code</label>
                <input
                  type="text"
                  className="form-control"
                  name="postalCode"
                  value={formData.postalCode}
                  onChange={handleInputChange}
                  placeholder="Enter postal code"
                />
              </div>
            </div>
          </>
        )}

        {/* Salary */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Salary</label>
            <input
              type="number"
              className="form-control"
              name="salary"
              value={formData.salary}
              onChange={handleInputChange}
              placeholder="Enter minimum salary"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Max Salary</label>
            <input
              type="number"
              className="form-control"
              name="maxSalary"
              value={formData.maxSalary}
              onChange={handleInputChange}
              placeholder="Enter max salary"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Currency</label>
            <select
              name="currency"
              className="form-select"
              value={formData.currency}
              onChange={handleInputChange}
            >
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
            </select>
          </div>
        </div>

        {/* Responsibilities, Skills, and Requirements */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">Responsibilities</label>
            <textarea
              className="form-control"
              name="responsibilities"
              value={formData.responsibilities}
              onChange={handleInputChange}
              placeholder="Enter responsibilities"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">Skills</label>
            <textarea
              className="form-control"
              name="skills"
              value={formData.skills}
              onChange={handleInputChange}
              placeholder="Enter skills"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Education Requirements</label>
            <textarea
              className="form-control"
              name="educationRequirements"
              value={formData.educationRequirements}
              onChange={handleInputChange}
              placeholder="Enter education requirements"
              rows="3"
            ></textarea>
          </div>
          <div className="col-md-6">
            <label className="form-label">Experience Requirements</label>
            <textarea
              className="form-control"
              name="experienceRequirements"
              value={formData.experienceRequirements}
              onChange={handleInputChange}
              placeholder="Enter experience requirements"
              rows="3"
            ></textarea>
          </div>
        </div>

        {/* Submit Button */}
        <button type="submit" className="btn btn-success w-100">
          Generate Schema
        </button>
      </form>
        </div>



      {/* JSON-LD Preview */}
      <div className="col-lg-6">
          <div className="card shadow-sm p-2">
            <h5 className="card-title text-center mb-4">Generated JSON-LD</h5>
            <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={copyToClipboard}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>
              <JSONPretty  id="json-pretty" data={schema}></JSONPretty>
            
          </div>
        </div>
              </div>
    </div>
  );
};

export default JobPostingSchemaForm;
